<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14LHvvg/tc-custom/9783968651767.jpg" alt="This image is the cover for the book Amazing Stories Volume 11, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amazing Stories Volume 11, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Great collection of action short stories from "The Golden Age of Science Fiction". Featured here: "Sphere of the Never-Dead" by Sam Carson, "The Space Flame" by Alexander M. Phillips, and "Silence is-- Deadly" by Bertrand L. Shurtleff, and "Revolt on the Earth-Star" by Carl Selwyn.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sam Carson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?62d2df25